module.exports = __webpack_public_path__ + "static/media/stop_sales_item.9aef5f47.svg";